import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 9, viewBox: "0 0 12 9", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.495 1.49498L4.505 8.48496L0.505035 4.485L1.49498 3.49505L4.505 6.50507L10.505 0.505028L11.495 1.49498Z" }));
export default SvgCheck;
